import type { ReactElement, ReactNode } from 'react'
import { useT } from '../../i18n/useI18n'
import './account.css'

export default function AccountLayout({ title, lead, children }: { title: string; lead?: string; children: ReactNode }): ReactElement {
  const t = useT()
  return (
    <section className="section ac-page">
      <div className="container">
        <div className="ac-card">
          <div className="ac-eyebrow"><i className="bi bi-person-circle" aria-hidden="true" /> {t('account.eyebrow')}</div>
          <h1 className="ac-title">{title}</h1>
          {lead !== undefined && <p className="ac-lead">{lead}</p>}
          {children}
        </div>
      </div>
    </section>
  )
}
